module.exports = __webpack_public_path__ + "static/media/720D06F5-5454-43DC-8374-776E5283EAB5.bf2ea3b9.JPG";